const ROLE = {
    ADMIN: 'admin',
    OPERATOR: 'operator',
    SELLER: 'seller'
};

export function setUser(state, user) {
    if (user) {
        state.user.data = user;
        state.user.loggedIn = true,
            state.user.isAdmin = user.ur === ROLE.ADMIN;
        state.user.isOperator = user.ur === ROLE.OPERATOR;
        state.user.isSeller = user.ur === ROLE.SELLER;



        // Save user data to localStorage
        localStorage.setItem('USER', JSON.stringify(state.user.data));

        if (state.user.isAdmin) {
            localStorage.setItem('USERROLE', 'Admin');
        } else if (state.user.isOperator) {
            localStorage.setItem('USERROLE', 'Operator');
        } else if (state.user.isSeller) {

            localStorage.setItem('USERROLE', 'Seller');
        }

        localStorage.setItem('LOGGEDIN', state.user.loggedIn)
    } else {
        // Clear user data from localStorage
        localStorage.removeItem('USER');
        localStorage.removeItem('USERROLE');
        localStorage.removeItem('LOGGEDIN');
    }
}

export function setToken(state, token) {
    state.user.token = token;
    if (token) {
        localStorage.setItem('TOKEN', token);
    } else {
        localStorage.removeItem('TOKEN')
    }
}

export function setOperators(state, [loading, data = null]) {
    if (data) {
        state.operators = {
            ...state.operators,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.operators.loading = loading;
}

export function setAllCategories(state, [loading, data = null]) {
    if (data) {
        state.allCategories = {
            ...state.allCategories,
            data: data.data,
        }
    }
    state.allCategories.loading = loading;
}

export function setAllTags(state, [loading, data = null]) {
    if (data) {
        state.allTags = {
            ...state.allTags,
            data: data.data,
        }
    }
    state.allTags.loading = loading;
}

export function setCategoriesWithAttributes(state, [loading, data = null]) {
    if (data) {
        state.categoriesWithAttributes = {
            ...state.categoriesWithAttributes,
            data: data.data,
        }
    }
    state.categoriesWithAttributes.loading = loading;
}

export function setCategoriesWithProducts(state, [loading, data = null]) {
    if (data) {
        state.categoriesWithProducts = {
            ...state.categoriesWithProducts,
            data: data.data,
        }
    }
    state.categoriesWithProducts.loading = loading;
}

export function setCategories(state, [loading, data = null]) {
    if (data) {
        state.categories = {
            ...state.categories,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.categories.loading = loading;
}

export function setAllAttributes(state, [loading, data = null]) {
    if (data) {
        state.allAttributes = {
            ...state.allAttributes,
            data: data.data,
        }
    }
    state.allAttributes.loading = loading;
}

export function setAttributesNoPagination(state, [loading, data = null]) {
    if (data) {
        state.attributesNoPagination = {
            ...state.attributesNoPagination,
            data: data.data,
        }
    }
    state.attributesNoPagination.loading = loading;
}

export function setAttributes(state, [loading, data = null]) {
    if (data) {
        state.attributes = {
            ...state.attributes,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.attributes.loading = loading;
}

export function setCategoryAttributes(state, [loading, data = null]) {
    if (data) {
        state.categoryAttributes = {
            ...state.categoryAttributes,
            data: data.data,
        }

    }

    state.categoryAttributes.loading = loading;
}

export function setValues(state, [loading, data = null]) {
    if (data) {
        state.values = {
            ...state.values,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.values.loading = loading;
}

export function setAttributeValues(state, [loading, data = null]) {
    if (data) {
        state.attributeValues = {
            ...state.attributeValues,
            data: data.data,
        }

    }

    state.attributeValues.loading = loading;
}

export function setProducts(state, [loading, data = null]) {
    if (data) {
        state.products = {
            ...state.products,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.products.loading = loading;
}

export function setCreatorsWithProducts(state, [loading, data = null]) {
    if (data) {
        state.productCreators = {
            ...state.productCreators,
            data: data.data,
        }
    }
    state.productCreators.loading = loading;
}

export function setUsers(state, [loading, data = null]) {
    if (data) {
        state.users = {
            ...state.users,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.users.loading = loading;
}

export function setSliders(state, [loading, data = null]) {
    if (data) {
        state.sliders = {
            ...state.sliders,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.sliders.loading = loading;
}

export function setStores(state, [loading, data = null]) {
    if (data) {
        state.stores = {
            ...state.stores,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.stores.loading = loading;
}

export function setOrders(state, [loading, data = null]) {
    if (data) {
        state.orders = {
            ...state.orders,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.orders.loading = loading;
}

export function setTransactions(state, [loading, data = null]) {
    if (data) {
        state.transactions = {
            ...state.transactions,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.transactions.loading = loading;
}

export function setWalletTransactions(state, [loading, data = null]) {
    if (data) {
        state.walletTransactions = {
            ...state.walletTransactions,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.walletTransactions.loading = loading;
}

export function setBanners(state, [loading, data = null]) {
    if (data) {
        state.banners = {
            ...state.banners,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.banners.loading = loading;
}

export function setComments(state, [loading, data = null]) {
    if (data) {
        state.comments = {
            ...state.comments,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.comments.loading = loading;
}

export function setFaqs(state, [loading, data = null]) {
    if (data) {
        state.faqs = {
            ...state.faqs,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.faqs.loading = loading;
}

export function setMessages(state, [loading, data = null]) {
    if (data) {
        state.messages = {
            ...state.messages,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.messages.loading = loading;
}

export function setAllOccasionTypes(state, [loading, data = null]) {
    if (data) {
        state.allOccasionTypes = {
            ...state.allOccasionTypes,
            data: data.data,
        }
    }
    state.allOccasionTypes.loading = loading;
}

export function setOccasionTypesWithOccasions(state, [loading, data = null]) {
    if (data) {
        state.occasionTypesWithOccasions = {
            ...state.occasionTypesWithOccasions,
            data: data.data,
        }
    }
    state.occasionTypesWithOccasions.loading = loading;
}

export function setOccasions(state, [loading, data = null]) {
    if (data) {
        state.occasions = {
            ...state.occasions,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.occasions.loading = loading;
}

export function setAllStoreSales(state, [loading, data = null]) {
    if (data) {
        state.allStoreSales = {
            ...state.allStoreSales,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.allStoreSales.loading = loading;
}

export function setTags(state, [loading, data = null]) {
    if (data) {
        state.tags = {
            ...state.tags,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.tags.loading = loading;
}

export function setCooperationRequests(state, [loading, data = null]) {
    if (data) {
        state.cooperationRequests = {
            ...state.cooperationRequests,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.cooperationRequests.loading = loading;
}

export function setAllStoreSettlements(state, [loading, data = null]) {
    if (data) {
        state.allStoreSettlements = {
            ...state.allStoreSettlements,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        }

    }

    state.allStoreSettlements.loading = loading;
}

export function setBestSellingProducts(state, [loading, data = null]) {
    if (data) {
        state.bestSellingProducts = {
            ...state.bestSellingProducts,
            data: data.data,
        }

    }

    state.bestSellingProducts.loading = loading;
}

export function setTopSellingStores(state, [loading, data = null]) {
    if (data) {
        state.topSellingStores = {
            ...state.topSellingStores,
            data: data.data,
        }

    }

    state.topSellingStores.loading = loading;
}

export function setLastPendingOrders(state, [loading, data = null]) {
    if (data) {
        state.lastPendingOrders = {
            ...state.lastPendingOrders,
            data: data.data,
        }

    }

    state.lastPendingOrders.loading = loading;
}
